import { handleEvent } from '../../helpers';

export default class {
  constructor(el) {
    this.el = el;
    this.images = this.el.querySelector('.animate-images-on-scroll');
    this.img1 = this.images.querySelectorAll('img')[0];
    this.img2 = this.images.querySelectorAll('img')[1];
    this.img3 = this.images.querySelectorAll('img')[2];
    this.dull = this.el.getAttribute('data-dull');
  }

  init() {
    this.handleEvents();
  }

  // setup scroll event
  handleEvents() {
    this.scroll = handleEvent('scroll', {
      el: window,
      preventDefault: true,
      stopPropagation: true,
      callback: this.onScroll.bind(this)
    });
  }

  // on scroll
  // adjust amount based on dullParallax option in Craft
  onScroll() {
    if(this.img2) {
      if(this.dull == 'true') {
        this.img2.style.transform = `translateY(${window.scrollY/6}px)`
      } else {
        this.img2.style.transform = `translateY(${window.scrollY/5}px)`
      }
    }
    if(this.img3) {
      if(this.dull == 'true') {
        this.img3.style.transform = `translateY(${window.scrollY/5}px)`;
      } else {
        this.img3.style.transform = `translateY(${window.scrollY/3.5}px)`;
      }

    }
  }

  // cleanup
  destroy() {
    this.scroll.destroy();
  }

}
